import { getCommonListingPageSeoProps, getOpenGraphUrl, getPageSeoBreadcrumbs } from './SeoHelpers';

import type { INewProductsPageUrlParams, PageSeoProps, TFunction } from 'types';

export function getNewProductsPageSeoProps(
  t: TFunction,
  urlParams: INewProductsPageUrlParams
): PageSeoProps {
  return {
    seoProps: {
      ...getCommonListingPageSeoProps(urlParams),
      title: `${t('NAVIGATION.NEW_PRODUCTS')}`,
      description: `${t('SEO.NEW_PRODUCTS.DESCRIPTION')}`,
      openGraph: {
        description: `${t('SEO.NEW_PRODUCTS.DESCRIPTION')}`,
        url: getOpenGraphUrl()
      },
    },
    breadcrumbs: getPageSeoBreadcrumbs(t)
  };
}
